

import templateComponent from '@/app-template/lib/components/Slides.vue';

export default {
  components: { templateComponent },
};
